// Initialize Firebase
export const firebaseConfig = {
  apiKey: "AIzaSyD1riYjAhpRf1bbds3uYGb-Kzr35p-5Eck",
  authDomain: "slow-band-auth.firebaseapp.com",
  databaseURL: "https://slow-band-auth.firebaseio.com",
  projectId: "slow-band-auth",
  storageBucket: "slow-band-auth.appspot.com",
  messagingSenderId: "910770562803",
  appId: "1:910770562803:web:4f7f1c3ab4eaf28cd53986",
  measurementId: "G-YXESVLP515"
};
